import React from 'react';
import { useState } from 'react';
import DynamicMenu from './DynamicMenu';

const StickyOffCanvasMenu = ({ isAdvisorView = false }) => {
	const [menuState, setMenuState] = useState(false);
	const setMenuToggleState = (currentState) => {
		setMenuState(currentState);
	};

	return (
		<>
			<DynamicMenu />
		</>
	);
};

export default StickyOffCanvasMenu;
